import { useState } from 'react';
import TranslationInput from '../ItemEditor/TranslationInput';
import IconButton from '../IconButton/IconButton';
import Button from '../Button/Button';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import { BLOG_SECTION_TYPES, createBlogSection } from './blogSectionTypes';
import '../ItemEditor/SectionEditor.css';
import './BlogSectionList.css';

const sectionLabel = (section, idx) =>
  section.heading.en.trim() || `${BLOG_SECTION_TYPES[section.type].label} ${idx + 1}`;

const swap = (list, from, to) => {
  const next = [...list];
  [next[from], next[to]] = [next[to], next[from]];
  return next;
};

const BlogSectionList = ({ sections, onChange, disabled }) => {
  const [confirmDeleteIdx, setConfirmDeleteIdx] = useState(null);

  const replaceSection = (idx, section) =>
    onChange(sections.map((s, i) => (i === idx ? section : s)));

  const removeSection = (idx) => {
    onChange(sections.filter((_, i) => i !== idx));
    setConfirmDeleteIdx(null);
  };

  return (
    <div className="section-editor">
      {sections.map((section, idx) => {
        const { icon, Fields } = BLOG_SECTION_TYPES[section.type];
        return (
          <fieldset className="section-panel blog-section-panel" key={idx} disabled={disabled}>
            <div className="section-header">
              <span className="material-symbols-outlined blog-section-icon">{icon}</span>
              <span className="section-title blog-section-title">{sectionLabel(section, idx)}</span>
              <IconButton
                icon="arrow_upward"
                onClick={() => onChange(swap(sections, idx, idx - 1))}
                disabled={idx === 0}
                aria-label="Move section up"
              />
              <IconButton
                icon="arrow_downward"
                onClick={() => onChange(swap(sections, idx, idx + 1))}
                disabled={idx === sections.length - 1}
                aria-label="Move section down"
              />
              <IconButton
                icon="delete"
                variant="danger"
                onClick={() => setConfirmDeleteIdx(idx)}
                aria-label="Remove section"
              />
            </div>
            <div className="section-body">
              <TranslationInput
                label="Heading (optional)"
                value={section.heading}
                onChange={(lang, val) => replaceSection(idx, { ...section, heading: { ...section.heading, [lang]: val } })}
              />
              <Fields section={section} onChange={(updated) => replaceSection(idx, updated)} />
            </div>
          </fieldset>
        );
      })}

      <div className="blog-section-add">
        {Object.entries(BLOG_SECTION_TYPES).map(([type, { label, icon }]) => (
          <Button
            key={type}
            variant="secondary"
            size="sm"
            onClick={() => onChange([...sections, createBlogSection(type)])}
            disabled={disabled}
          >
            <span className="material-symbols-outlined">{icon}</span>
            Add {label.toLowerCase()}
          </Button>
        ))}
      </div>

      {confirmDeleteIdx !== null && (
        <ConfirmModal
          title="Remove Section"
          message={`Remove "${sectionLabel(sections[confirmDeleteIdx], confirmDeleteIdx)}"? This cannot be undone.`}
          confirmLabel="Remove"
          onConfirm={() => removeSection(confirmDeleteIdx)}
          onCancel={() => setConfirmDeleteIdx(null)}
        />
      )}
    </div>
  );
};

export default BlogSectionList;
